import { render, staticRenderFns } from "./FixedHeader.vue?vue&type=template&id=d53a4396&"
import script from "./FixedHeader.vue?vue&type=script&lang=js&"
export * from "./FixedHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports